import React from "react";
import { FileText, CalendarDays, Hash, BadgeInfo, Banknote, IdCard } from "lucide-react";
import { Sekcja, RowIcon, mono } from "./atoms";

// PLN formatter (reused)
const pln = (v) => {
  if (v == null || v === "" || v === "-") return <em>—</em>;
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  return n.toLocaleString("pl-PL", { style: "currency", currency: "PLN", maximumFractionDigits: 2 });
};

export default function EuGrantsSection({ items = [] }) {
  return (
    <Sekcja
      title="Dotacje UE"
      icon={FileText}
      titleStyle={{ fontSize: 20, color: "#0b74e5", textDecorationThickness: "2px", textUnderlineOffset: 4 }}
    >
      {Array.isArray(items) && items.length > 0 ? (
        <div style={{ display: "grid", gap: 12 }}>
          {items.map((g, i) => (
            <div key={g?.id ?? i}>
              {/* Nagłówek wpisu: nazwa programu + rok */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 8,
                  marginBottom: 4,
                }}
              >
                <div style={{ display: "inline-flex", alignItems: "center", gap: 8, fontWeight: 700 }}>
                  <FileText size={16} />
                  <span>{g?.programmeName || "—"}</span>
                </div>
                <div style={{ fontSize: 12, color: "#6b7280" }}>
                  Rok: <strong>{g?.grantYear || "—"}</strong>
                </div>
              </div>

              {/* Wiersze danych */}
              <RowIcon icon={Hash} label="ID">
                {g?.id ? mono(g.id) : <em>—</em>}
              </RowIcon>

              <RowIcon icon={IdCard} label="NIP">
                {g?.taxNumber ? mono(g.taxNumber) : <em>—</em>}
              </RowIcon>

              <RowIcon icon={BadgeInfo} label="Nr referencyjny">
                {g?.referenceNumber ? mono(g.referenceNumber) : <em>—</em>}
              </RowIcon>

              <RowIcon icon={FileText} label="Program">
                {g?.programmeName || <em>—</em>}
              </RowIcon>

              <RowIcon icon={FileText} label="Temat/Opis">
                {g?.subject || <em>—</em>}
              </RowIcon>

              <RowIcon icon={BadgeInfo} label="Typ wydatku">
                {g?.expenseType || <em>—</em>}
              </RowIcon>

              <RowIcon icon={Banknote} label="Kwota umowna">
                {pln(g?.contractedAmount)}
              </RowIcon>

              <RowIcon icon={Banknote} label="Kwota całkowita">
                {pln(g?.totalAmount)}
              </RowIcon>

              <RowIcon icon={CalendarDays} label="Okres od">
                {g?.projectPeriodStartDate || <em>—</em>}
              </RowIcon>

              <RowIcon icon={CalendarDays} label="Okres do">
                {g?.projectPeriodEndDate || <em>—</em>}
              </RowIcon>
            </div>
          ))}
        </div>
      ) : (
        <em>Brak dotacji UE.</em>
      )}
    </Sekcja>
  );
}
